import client from '@js/client'
import resources from '@js/resources'
import store from '@store/store'
import { camelKeyToSnakeKeyRecursive, snakeKeyToCamelKeyRecursive } from '@js/str-utils'
import { isAfterToday, isBeforeToday } from '@js/date-utils'

const getDefaultState = () => {
  return {
    id: null,
    name: '',
    domain: localStorage.getItem('tenant_domain') || '',
    image: null,
    description: null,
    licenseCount: 0,
    subscriptionType: null,
    subscribedAt: null,
    expiresAt: null,
    tenants: [],
  };
};

const tenant = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getImageUrl: state => {
      if (state.image && state.image.length > 0) {
        return state.image;
      }
      return "//:0";
    },
    getTenantDomain: state => state.domain,
    isEnterprise: (state, _, __, rootGetters) => {
      return (
        (state.subscriptionType === rootGetters[
          'globalVariables/enterpriseSubscriptionType']) &&
        (state.expiresAt === null || isAfterToday(state.expiresAt)) &&
        (state.subscribedAt === null || isBeforeToday(state.subscribedAt))
      );
    },
    tenantIsSelected: state => {
      return state.domain && state.domain.length > 0;
    },
  },
  mutations: {
    clearTenant (state) {
      localStorage.removeItem('tenant_domain');
      state.id = null;
      state.name = '';
      state.domain = '';
      state.image = null;
      state.description = '';
      state.licenseCount = 0,
      state.subscriptionType = null,
      state.subscribedAt = null,
      state.expiresAt = null,
      state.tenants = [];
    },
    initialize (state) {
      localStorage.removeItem('tenant_domain');
      Object.assign(state, getDefaultState());
    },
    //readLocalStorage (state) {
    //  state.domain = localStorage.getItem('tenant_domain') || '';
    //},
    //readTenantDomainFromLocalStorage (state) {
    //  return localStorage.getItem('tenant_domain') || '';
    //},
    //readLocalStorage (state) {
    //  state.domain = localStorage.getItem('tenant_domain') || '';
    //},
    /*selectTenant (state, { name, domain, description, }) {
      state.domain = domain;
      localStorage.setItem('tenant_domain', domain);
    },*/
    selectTenant (state, tenant) {
      Object.assign(state, tenant);
      localStorage.setItem('tenant_domain', state.domain);
    },
    setTenant (state, tenant) {
      Object.assign(state, tenant);
      localStorage.setItem('tenant_domain', state.domain);
    },
    setTenantDomain (state, domain) {
      state.domain = domain;
      localStorage.setItem('tenant_domain', domain);
    },
    /*
    setTenant (state, { id, name, domain, description, image, licenseCount, subscriptionType, subscribedAt, expiresAt }) {
      state.id = id;
      state.name = name;
      state.domain = domain;
      state.description = description;
      state.image = image;
      state.licenseCount = licenseCount;
      state.subscriptionType = subscriptionType;
      state.subscribedAt = subscribedAt;
      state.expiresAt = expiresAt;
      localStorage.setItem('tenant_domain', domain);
    },*/
    setTenantName (state, name) {
      state.name = name;
    },
    setTenants (state, { tenants, }) {
      state.tenants = tenants.map(elem => snakeKeyToCamelKeyRecursive(elem));
    },
  },
  actions: {
    async getUserTenants (ctx) {
      const userId = ctx.rootGetters['user/getUserId'];
      const res = await client.get(resources['users'] + `${userId}/tenants/`);
      await ctx.commit('setTenants', { tenants: res.data['tenants'], });
      return res;
    },
    async getTenant (ctx, { domain, }) {
      const res = await client.get(resources['tenants'](domain));
      await ctx.commit('setTenant', snakeKeyToCamelKeyRecursive(res.data));
      return res;
    },
    async updateTenantName ({ state, commit, rootGetters }, { name = null, description = null }) {
      if (name == null && description == null) {
        return;
      }
      const payload = {
        ...(name == null ? {} : { name: name }),
        ...(description == null ? {} : { description: description }),
      };

      const url = resources['tenants'](state.domain);
      const res = await client.put(url, camelKeyToSnakeKeyRecursive(payload));
      await commit('setTenant', snakeKeyToCamelKeyRecursive(res.data));
      return res;
    },
  },
};

export default tenant;
